// extracted by mini-css-extract-plugin
export var orderSummary = "_ti-0";
export var showMoreLessButton = "_ti-1";